<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header p-3 pt-2 d-flex align-items-center">
            <div
              class="icon icon-lg icon-shape shadow text-center border-radius-xl bg-gradient-success shadow-dark me-3"
              style="margin-top: -1.5rem">
              <i class="material-symbols-rounded opacity-10 text-white" aria-hidden="true">patient_list</i>
            </div>
            <h6 class="mb-0">{{ $t('association.Association') }}</h6>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="row mb-5">
          <div class="col-lg-3">
            <edit-association-side-nav />
          </div>
          <div class="col-lg-9 mt-lg-0 mt-4">
            <association-overview />
          </div>
        </div>
      </div>

    </div>
  </div>

</template>
<script>

import EditAssociationSideNav from "./components/EditAssociationSideNav.vue"
import AssociationOverview from "./components/AssociationOverview.vue"

export default {
  name: 'Association_details_page',
  components: {
    EditAssociationSideNav,
    AssociationOverview
  },
  data() {
    return {
      Id: '',
      association: [],
      gets: []
    }
  },
  async mounted() {
  },
}
</script>